import { render } from "./modal-glossary.component.vue?vue&type=template&id=d264966a"
import script from "./modal-glossary.component.vue?vue&type=script&lang=js"
export * from "./modal-glossary.component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__